export default __webpack_public_path__ + "static/media/ranjana_srivastava.a101791b.jpg";